module.exports = __webpack_public_path__ + "img/battery-exclamation.60fae641.svg";